/**
 * @flow
 * @relayHash 7b93b80d08a2515960e1ffc03bfd9b14
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteProductInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeleteProductMutationVariables = {|
  input: DeleteProductInput
|};
export type DeleteProductMutationResponse = {|
  +deleteProduct: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteProductMutation = {|
  variables: DeleteProductMutationVariables,
  response: DeleteProductMutationResponse,
|};
*/


/*
mutation DeleteProductMutation(
  $input: DeleteProductInput!
) {
  deleteProduct(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProductInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteProduct",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProductPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteProductMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteProductMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteProductMutation",
    "id": null,
    "text": "mutation DeleteProductMutation(\n  $input: DeleteProductInput!\n) {\n  deleteProduct(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd8026e8d9212b55493b371df77c56a33';
module.exports = node;
